module.exports = "<div class=\"ice-lg-margin-top\">\r\n  <mat-progress-bar [color]=\"color\" [mode]=\"mode\"></mat-progress-bar>\r\n</div>\r\n"